/**
 * Andre Garen - EK10 Faz 2 S007 Doku ile ara. Anahtar S007 (window.agOz). Arama katmani bosken kutunun altinda en cok 8 doku cipi
 * (B083 doku listesi ve etiketleri). Sayi gercek: secili dunyanin koleksiyonunda o etiketi tasiyan stoktaki parca
 * (/collections/<abiye|gunluk>/products.json, oturumda bir kez, sessionStorage ag:doku-say). Kirpim stoktaki ilk urunun
 * fotografindan (yalniz CSS olcek/konum; 3. kare varsa ayrinti karesi). Dokununca arama kutusuna doku yazilir, sonuclar secili
 * dunyadan (S096). Obur dunyadaki sayi baglanti olarak durur ("Gece'de 2"). Iki dunyada da urunu olmayan doku gizlenir.
 * 68 px daire, 76 px dokunma alani, her cipin metin etiketi var.
 */
(function () {
  'use strict';
  if (!(window.agOz && window.agOz('S007'))) return;
  var DOKU = [['Payet', 'payetli'], ['Saten', 'saten'], ['T\u00fcl', 't\u00fcl'], ['Dantel', 'dantel'], ['\u0130pek', 'ipek'], ['\u015eifon', '\u015fifon'], ['Keten', 'keten'], ['Sa\u00e7ak', 'sa\u00e7ak'], ['Metalik', 'metalik']];
  var DUNYA = { night: { h: 'abiye', ad: "Gece'de" }, day: { h: 'gunluk', ad: "G\u00fcnd\u00fcz'de" } };
  var KEY = 'ag:doku-say', kuruldu = false;
  function etiketler(p) { return (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map(function (t) { return String(t).trim().toLocaleLowerCase('tr'); }); }
  function topla(j) {
    var s = {};
    DOKU.forEach(function (d) {
      var l = (j.products || []).filter(function (p) { return p.variants.some(function (v) { return v.available; }) && etiketler(p).indexOf(d[1]) > -1; });
      var g = l[0] && (l[0].images[2] || l[0].images[0]);
      s[d[1]] = { n: l.length, img: g ? g.src : '' };
    });
    return s;
  }
  function veri() {
    try { var o = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (o && Date.now() - o.t < 18e5) return Promise.resolve(o); } catch (e) {}
    var al = function (h) { return fetch('/collections/' + h + '/products.json?limit=250', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(topla); };
    return Promise.all([al('abiye'), al('gunluk')]).then(function (r) { var o = { t: Date.now(), night: r[0], day: r[1] }; try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} return o; });
  }
  function kur() {
    if (kuruldu) return; kuruldu = true;
    var layer = document.querySelector('[data-ag-search]'), pop = layer && layer.querySelector('[data-ag-search-popular]'), input = layer && layer.querySelector('[data-ag-search-input]');
    if (!pop || !input) return;
    var kap = document.createElement('div'); kap.className = 'ag-doku-ara'; kap.setAttribute('data-ag-doku-ara', '');
    pop.parentNode.insertBefore(kap, pop);
    veri().then(function (v) {
      var m = document.documentElement.getAttribute('data-ag-mode') === 'night' ? 'night' : 'day', o = m === 'night' ? 'day' : 'night';
      var ogeler = DOKU.filter(function (d) { return v[m][d[1]].n > 0 || v[o][d[1]].n > 0; }).slice(0, 8);
      if (!ogeler.length) { kap.remove(); return; }
      kap.innerHTML = '<div class="ag-eyebrow">Doku ile ara</div><ul class="ag-doku-ara__liste" role="list">' + ogeler.map(function (d) {
        var b = v[m][d[1]], s = v[o][d[1]], img = b.img || s.img;
        var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        return '<li class="ag-doku-ara__oge">' +
          '<button type="button" class="ag-doku-ara__cip" data-ag-doku-ara-cip="' + d[0] + '"' + (b.n ? '' : ' disabled') + ' aria-label="' + d[0] + (b.n ? ', ' + b.n + ' par\u00e7a' : ', bu d\u00fcnyada yok') + '">' +
          '<span class="ag-doku-ara__daire">' + (src ? '<img src="' + src + '" alt="" width="68" height="68" loading="lazy">' : '') + '</span>' +
          '<span class="ag-doku-ara__ad">' + d[0] + '</span><span class="ag-doku-ara__sayi">' + b.n + '</span></button></li>';
      }).join('') + '</ul>';
    }).catch(function () { kap.remove(); });
    kap.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ag-doku-ara-cip]'); if (!c || c.disabled) return;
      input.value = c.getAttribute('data-ag-doku-ara-cip'); input.dispatchEvent(new Event('input', { bubbles: true })); input.focus({ preventScroll: true });
      /* plan uyum: obur dunyanin sayisi sonuc basliginda tek satir */
      veri().then(function (v) {
        var m = document.documentElement.getAttribute('data-ag-mode') === 'night' ? 'night' : 'day', o = m === 'night' ? 'day' : 'night';
        var d = DOKU.filter(function (x) { return x[0] === c.getAttribute('data-ag-doku-ara-cip'); })[0], s = d && v[o][d[1]];
        var res = layer.querySelector('[data-ag-search-results]'), el = layer.querySelector('[data-ag-doku-obur]');
        if (!el && res) { el = document.createElement('a'); el.className = 'ag-doku-ara__obur'; el.setAttribute('data-ag-doku-obur', ''); res.parentNode.insertBefore(el, res); }
        if (!el) return;
        if (s && s.n) { el.href = '/collections/' + DUNYA[o].h + '/' + encodeURIComponent(d[1]); el.textContent = DUNYA[o].ad + ' ' + s.n + ' par\u00e7a daha \u2192'; el.hidden = false; } else el.hidden = true;
        input.addEventListener('input', function gizle() { el.hidden = true; input.removeEventListener('input', gizle); });
      });
    });
    input.addEventListener('input', function () { kap.hidden = !!input.value.trim(); });
  }
  var layer = document.querySelector('[data-ag-search]');
  if (!layer) return;
  if (!layer.hidden) kur();
  new MutationObserver(function () { if (!layer.hidden) kur(); }).observe(layer, { attributes: true, attributeFilter: ['hidden'] });
})();
